<template>
  <ActivityDeleteModal :show-modal="showDeleteModal" v-on:deleteActivityConfirmed="deleteActivityConfirmed"
                       v-on:modalClosed="deleteModalClosed"></ActivityDeleteModal>

  <BuddySelectBar :initial-buddy-id="activity.buddy.id" :interactable="!isEdit" @buddyChanged="buddySelected"
                  ref="bsbComponent"></BuddySelectBar>

  <div class="container">
    <div class="row mt-3 agenda-cards">
      <div class="col-lg-4">
        <div class="card plan-activity-card mt-0">
          <p class="title" v-if="notExpired">Activiteit plannen</p>
          <p class="title" v-else>Activiteit</p>

          <div v-if="notExpired" class="date-input-wrapper">
            <i class="fas fa-calendar-alt"></i>
            <div class="date-picker">
              <DateSelector id="start-date" name="trip-start" v-model:date="plannedDate" @change="onDateSelected"/>
            </div>
          </div>

          <div v-else class="date-input-wrapper">
            <i class="fas fa-calendar-alt"></i>
            <p>{{ plannedDate?.toLocaleDateString("nl-BE") }}</p>
          </div>

          <div v-if="notExpired" class="time-input-wrapper">
            <i class="far fa-clock"></i>
            <div class="time-picker">
              <TimeSelector id="start-time" name="trip-start" v-model:date="plannedTime" @change="onTimeSelected"/>
            </div>
          </div>

          <div v-else class="time-input-wrapper">
            <i class="far fa-clock"></i>
            <p>{{ plannedDate?.toLocaleTimeString("nl-BE") }}</p>
          </div>

          <div v-if="fetchingQuest">
            <div class="alert alert-info" role="alert">
              Activiteit ophalen.
            </div>
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="sr-only">Laden...</span>
              </div>
            </div>
          </div>
          <IconDropdownButton v-else-if="!activitySelected" iconName="fas fa-bolt" buttonText="Activiteit selecteren"
                              :invertedStyle="true" @click="openActivitySelect"></IconDropdownButton>
          <QuestSelectedButton v-if="activitySelected" :quest="activity.quest"></QuestSelectedButton>

          <v-button v-if="notExpired" :buttonText="activity?.plannedDate? 'Bewerken':'Activiteit inplannen'"
                    :enabled="isValid"
                    @click="planActivityClicked"></v-button>
          <a v-if="activity?.plannedDate && notExpired" class="cancel-button" href="#"
             v-on:click.prevent="cancelClicked">Bewerken
            annuleren</a>
          <button v-if="activity?.plannedDate && notExpired" class="btn btn-link delete-activity-btn" type="button"
                  @click="deleteActivityClicked">Activiteit
            verwijderen
          </button>
        </div>
      </div>

      <template v-if="activity.quest">
        <div class="col-lg-8" v-if="activity.quest.type !== questTypeEnum.impulse">
          <div class="col-lg-6">
            <QuestSummaryPanel :quest="activity.quest" :enable-plan-btn="false" :show-impulse-info="true"/>
          </div>
          <div class="col-lg-6">
            <QuestDetailPanel :quest="activity.quest"/>
          </div>
        </div>
        <div class="col-lg-8" v-else>
          <div class="row">
            <div class="col-lg-6">
              <QuestSummaryPanel :quest="activity.quest" :enable-plan-btn="false" :show-impulse-info="true"/>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BuddySelectBar from "@/components/Common/BuddySelectBar";
import QuestSelectedButton from "@/components/Quests/QuestSelectedButton";
import VButton from "@/components/UI/VButton";
import DateFormatter from "@/mixins/DateFormatter";
import { ActivityApi, QuestApi, QuestTypeEnum } from "sandpiper_api";
import log from "@/utils/logger";
import DateSelector from "@/components/UI/DateSelector";
import TimeSelector from "@/components/UI/TimeSelector";
import QueryParamDateHelper from "@/mixins/QueryParamDateHelper";
import QuestSummaryPanel from "@/components/Quests/QuestSummaryPanel";
import QuestDetailPanel from "@/components/Quests/QuestDetailPanel";
import ActivityDeleteModal from "@/components/Activities/DeleteActivityModal.vue";
import IconDropdownButton from "@/components/UI/IconDropdownButton";


export default {
  name: "Agenda",
  components: {
    QuestDetailPanel,
    QuestSummaryPanel,
    TimeSelector,
    DateSelector,
    BuddySelectBar,
    QuestSelectedButton,
    VButton,
    ActivityDeleteModal,
    IconDropdownButton
  },
  mixins: [ DateFormatter, QueryParamDateHelper ],
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      fetchingQuest: false,
      selectedQuestId: null,
      fetchingActivity: false,
      notExpired: false,
      activity: {
        buddy: {}
      },

      showAgendaContainer: true,
      activitySelected: false,

      plannedDate: null,
      plannedTime: null,

      showDeleteModal: false,

      questTypeEnum: new QuestTypeEnum(),
    }
  },
  watch: {
    plannedDate()
    {
      if (!this.activity?.plannedDate)
      {
        this.onDateSelected();
      }
    },
    plannedTime()
    {
      if (!this.activity?.plannedDate)
      {
        this.onTimeSelected();
      }
    }
  },
  computed: {
    isEdit()
    {
      return !!this.$route.params.id;
    },
    submitButtonEnabled()
    {
      return this.activitySelected;
    },
    isValid()
    {
      if (!this.plannedDate || !this.plannedTime)
      {
        return false;
      }

      if (this.activitySelected === false)
      {
        return false;
      }

      return true;
    }
  },
  methods: {
    fetchPathParams()
    {
      this.activityId = this.$route.params.id;
    },
    buddySelected(buddy)
    {
      // Don't update when activity is being fetched
      if (!this.fetchingActivity)
      {
        this.activity.buddy = buddy;
      }
    },
    onDateSelected()
    {
      log.info("[PlanActivity] date selected");
      if (this.plannedDate !== null)
      {
        sessionStorage.setItem("BBUDSelectedDate", this.plannedDate.getTime());
      }
    },
    onTimeSelected()
    {
      log.info("[PlanActivity] time selected");
      if (this.plannedTime !== null)
      {
        sessionStorage.setItem("BBUDSelectedTime", this.plannedTime.getTime());
      }
      this.timeDropdownOpen = false;
    },
    planActivityClicked()
    {
      log.info("[PlanActivity] plan activity clicked");
      // TODO - clear activity data from session/local storage
      this.saveActivity();
    },
    deleteActivityClicked()
    {
      this.showDeleteModal = true;
    },
    deleteModalClosed()
    {
      this.showDeleteModal = false;
    },
    deleteActivityConfirmed()
    {
      this.deleteActivity();
    },
    cancelClicked()
    {
      this.$router.push({ name: "agenda" });
    },
    openActivitySelect()
    {
      this.$router.push({
        name: "quests", query: {
          buddy: this.activity.buddy.id
        }
      });
    },
    checkNotExpired()
    {
      console.log("checking not expired with " + this.plannedDate)
      if (!this.plannedDate) return true;

      let d = new Date();
      d.setDate(d.getDate() - 1);
      if (this.plannedDate < d)
      {
        //event is at least 1 day ago
        return false;
      }
      else
      {
        return true;
      }
    },
    async fetchQuest()
    {
      try
      {
        this.fetchingQuest = true;
        const response = await this.doApiRequest(() => new QuestApi().getQuest(this.selectedQuestId));

        log.info("Fetch quest response: %o", response);
        this.activity.quest = response;
        this.activitySelected = true;
      }
      catch (e)
      {
        // TODO - handle exception
      }
      finally
      {
        this.fetchingQuest = false;
        this.notExpired = this.checkNotExpired();
      }
    },
    async fetchActivity()
    {
      try
      {
        this.fetchingActivity = true;
        const response = await this.doApiRequest(() => new ActivityApi().getActivity(this.activityId));

        log.info("Fetch activity response: %o", response);
        this.activity = response;

        if (this.activity.startedDate !== null || this.activity.completionDate !== null)
        {
          await this.$router.push({
            name: "activity-detailed", params: {
              id: this.activity.id
            }
          });
        }

        this.plannedDate = new Date(this.activity.plannedDate);
        this.plannedTime = new Date(this.activity.plannedDate);

        this.activitySelected = true;

        this.$refs.bsbComponent.overrideBuddy(this.activity.buddy);
      }
      catch (e)
      {
        // TODO - handle exception
      }
      finally
      {
        this.fetchingActivity = false;
      }
    },
    async saveActivity()
    {
      try
      {
        this.savingActivity = true;

        this.activity.plannedDate = new Date(this.plannedDate.getFullYear(), this.plannedDate.getMonth(),
            this.plannedDate.getDate(), this.plannedTime.getHours(), this.plannedTime.getMinutes());

        if (this.isEdit)
        {
          await this.doApiRequest(() => new ActivityApi().updateActivity(this.activity.id, this.activity));
        }
        else
        {
          await this.doApiRequest(() => new ActivityApi().createActivity(this.activity));
        }

        sessionStorage.removeItem("BBUDSelectedDate");
        sessionStorage.removeItem("BBUDSelectedTime");

        await this.$router.push({ name: "agenda" });
      }
      catch (e)
      {
        // TODO - handle exception
      }
      finally
      {
        this.savingActivity = false;
      }
    },
    async deleteActivity()
    {
      try
      {
        this.savingActivity = true;

        await this.doApiRequest(() => new ActivityApi().deleteActivity(this.activity.id));

        sessionStorage.removeItem("BBUDSelectedDate");
        sessionStorage.removeItem("BBUDSelectedTime");

        await this.$router.push({ name: "agenda" });
      }
      catch (e)
      {
        // TODO - handle exception
      }
      finally
      {
        this.savingActivity = false;
      }
    },
  },
  created()
  {
    if (this.isEdit)
    {
      this.fetchPathParams();
      this.fetchActivity();
      this.notExpired = this.checkNotExpired();
    }
    else
    {
      let savedDate = new Date(parseInt(sessionStorage.getItem("BBUDSelectedDate")));
      // Query param has priority over session storage
      if (this.$route.query.initialDate)
      {
        this.plannedDate = this.parseDateFromQueryParam(this.$route.query.initialDate);
      }
      else if (sessionStorage.getItem("BBUDSelectedDate") !== null)
      {
        if (savedDate >= new Date)
        {
          this.plannedDate = savedDate;
        }
        else
        {
          this.plannedDate = new Date();
        }
      }

      if (sessionStorage.getItem("BBUDSelectedTime") !== null)
      {
        this.plannedTime = new Date(parseInt(sessionStorage.getItem("BBUDSelectedTime")));
      }
    }

    if (this.$route.query.questId)
    {
      this.selectedQuestId = this.$route.query.questId;
      this.fetchQuest();
    }

    this.notExpired = this.checkNotExpired();

  }
}
</script>

<style lang="scss" scoped>
.agenda-cards {
  align-items: flex-start;
}

.card {
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
  margin-top: 25px;

  .title {
    font-size: 1rem;
    font-weight: bold;
  }

  .subtitle {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.plan-activity-card {
  p {
    margin: 1rem 0rem;
  }

  > div, button {
    margin-top: 1rem;
  }
}

.cancel-button {
  text-decoration: underline;
  font-size: $title-size;
  text-align: center;
  margin-top: 1rem;
  color: $primary-blue;
}

.dropdown-btn {
  &:focus {
    box-shadow: $default-shadow !important;
  }
}

.date-picker {
  display: flex;
  flex-direction: column;
}

.date-picker, .time-picker {
  flex-grow: 1;
}

.delete-activity-btn {
  color: $error;
  font-weight: 500;
  text-decoration: underline;
}

.date-input-wrapper, .time-input-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  color: $font-dark;
  font-size: 1rem;
  font-weight: bold;
  padding: 0.375rem 0.75rem;

  height: 50px;
  border-radius: 5px;
  box-shadow: $default-shadow;

  i {
    margin-right: 0.5rem;
    //flex-grow: 1;
    font-size: 1.3rem;
  }

  span {
    flex-grow: 6;
    text-align: left;
  }
}

.date-input-wrapper {
  margin-top: 0px !important;
}
</style>